























































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { BPCTable, BPCTableField } from '@shared/interfaces/bpc-table-interface';
import { Booking, ProfieMyBookingRequestsFilters } from '@bookings/interfaces/booking';
import PaginationInterface from '@core/interfaces/pagination-interface';
import OrderingInterface from '@core/interfaces/ordering-interface';
import TableWrapper from '@shared/layouts/wrappers/table/table-wrapper.vue';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import Table from '@shared/components/tables/table.vue';
import { isNull } from 'lodash';
import DisplayFieldCode from '@shared/components/displays/display-field-code/display-field-code.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import { mixins } from 'vue-class-component';

import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import { SelectOptionInterface } from '@shared/interfaces/inputs';
import DisplayFieldArray from '@shared/components/displays/display-field-array/display-field-array.vue';
import DisplayFieldDays from '@shared/components/displays/display-field-days/display-field-days.vue';
import DisplayFieldDateRange from '@shared/components/displays/display-field-date-range/display-field-date-range.vue';
import DisplayFieldTimeRange from '@shared/components/displays/display-field-time-range/display-field-time-range.vue';
import DisplayFieldAmount from '@shared/components/displays/display-field-amount/display-field-amount.vue';
import DisplayFieldBadge from '@shared/components/displays/display-field-badge/display-field-badge.vue';
import PublicBookingRequestCancelModal from '@bookings/components/modals/public-booking-request-cancel-modal.vue';
import PublicBookingRequestViewModal from '@bookings/components/modals/public-booking-request-view-modal.vue';

const defaultTableFields: BPCTableField[] = [
  {
    key: 'code',
    headerLabel: `global.booking.code`,
    order: 0,
  },
  {
    key: 'date_range',
    headerLabel: `global.booking.date_range`,
    order: 1,
  },
  {
    key: 'time_range',
    headerLabel: `global.booking.time_range`,
    order: 2,
  },
  {
    key: 'days',
    headerLabel: `global.booking.days`,
    order: 3,
  },
  {
    key: 'resources',
    headerLabel: `global.booking.resources`,
    order: 4,
  },
  {
    key: 'booking_price',
    headerLabel: `global.booking.price`,
    order: 5,
  },
  {
    key: 'status',
    headerLabel: `global.booking.status`,
    order: 6,
  },
];

@Component({
  name: 'bc-profile-my-booking-request-table',
  components: {
    'bc-multi-select': MultiSelect,
    'bpc-drawer-modal': DrawerModal,
    'bpc-entity-select': EntitySelect,
    'bpc-content-wrapper': ContentWrapper,
    'bpc-table-wrapper': TableWrapper,
    'bpc-table': Table,
    'bpc-display-code': DisplayFieldCode,
    'bpc-display-array': DisplayFieldArray,
    'bpc-display-days': DisplayFieldDays,
    'bpc-display-date-range': DisplayFieldDateRange,
    'bpc-display-time-range': DisplayFieldTimeRange,
    'bpc-display-amount': DisplayFieldAmount,
    'bpc-display-badge': DisplayFieldBadge,
    'bc-public-booking-request-cancel-modal': PublicBookingRequestCancelModal,
    'bc-public-booking-request-view-modal': PublicBookingRequestViewModal,
  },
})
export default class ProfileMyBookingRequestTable extends mixins(Vue) implements BPCTable {
  // PROPS
  @Prop({ type: String }) readonly actionsPortalTarget: string;
  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;
  @Prop({ type: Boolean, default: false }) readonly isInput: boolean;
  @Prop({ type: Boolean, default: true }) readonly showFilters: boolean;
  @Prop({ type: Boolean, default: true }) readonly showOrdering: boolean;
  @Prop({ type: Boolean, default: false }) readonly withUrlParams: boolean;
  @Prop({ type: String, default: 'start_date' }) readonly orderBy: string;
  @Prop({ type: String, default: 'desc' }) readonly orderDirection: string;
  @Prop({ type: Object }) readonly initialFilters: ProfieMyBookingRequestsFilters;
  @Prop({
    default() {
      return defaultTableFields;
    },
  })
  readonly tableFields: BPCTableField[];

  // DATA
  loading: boolean = false;
  booking: Booking = null;

  bookings: Booking[] = [];
  filters: ProfieMyBookingRequestsFilters = {
    status: null,
  };
  // pagination
  pageOptions: number[] = [5, 10, 15, 20, 50, 100, 200];
  pagination: PaginationInterface = {
    current_page: 1,
    last_page: 1,
    per_page: 15,
    from: 0,
    to: 0,
    total: 0,
  };
  ordering: OrderingInterface = {
    order_by: 'start_date',
    order_direction: 'desc',
  };
  orderByOptions: object[] = [
    {
      text: this.$t('global.booking.ordering.start_date.label'),
      value: 'start_date',
    },
  ];

  statusFilterOptions: SelectOptionInterface[] = [
    {
      text: this.$t('global.status.requested').toString(),
      value: 'requested',
    },
    {
      text: this.$t('global.fields.status.confirmed.label').toString(),
      value: 'confirmed',
    },
    {
      text: this.$t('global.fields.status.cancelled.label').toString(),
      value: 'cancelled',
    },
    {
      text: this.$t('global.fields.status.refused.label').toString(),
      value: 'refused',
    },
  ];
  statusFilterPlaceholder: string = this.$t('bookings.bookings.status.label').toString();

  // Cancel modal data
  public showCancelModal: boolean = false;
  // view modal data
  public showViewModal: boolean = false;

  public permissionEntityNameToUse = 'bookings';
  public pluralEntityName = 'booking-events';

  // COMPUTED
  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get tenantType(): string {
    return this.$store.getters['centerSettings/centerSettings']['center_type'] || 'center';
  }

  get permissionEntityName(): string {
    return 'bookings';
  }

  get showViewBookingRowAction(): boolean {
    return (
      !this.disabled &&
      this.$authorizationService.hasPermissionForAction(this.permissionEntityName, 'show')
    );
  }
  get showCancelBookingRowAction(): boolean {
    const hasPublicCancelPermission = this.$authorizationService.hasPermissionForAction(
      this.permissionEntityName,
      'manage_public_bookings',
      true,
    );

    return !this.disabled && hasPublicCancelPermission;
  }

  get fieldsToShow(): object[] {
    return this.tableFields.sort((f1, f2) => f1.order - f2.order);
  }

  get bookingId() {
    return this.booking?.id;
  }

  get displayCodeConfig(): object {
    return {
      displayType: 'code',
      key: 'code',
    };
  }
  get displayDateRangeConfig(): object {
    return {
      date_range: {
        sortable: false,
        displayType: 'date-range',
      },
    };
  }
  get displayTimeRangeConfig(): object {
    return {
      date_range: {
        displayType: 'time-range',
      },
    };
  }

  get displayResourceConfig(): object {
    return {
      displayType: 'array',
      fieldPath: 'code',
    };
  }

  get displayBookingPriceConfig(): object {
    return {
      displayType: 'amount',
      withTotalAmount: true,
    };
  }

  get displayStatusConfig(): object {
    return {
      inputType: 'select',
      displayType: 'badge',
      valueToLabel: [
        { value: 'cancelled', label: 'global.fields.status.cancelled.label' },
        { value: 'refused', label: 'global.fields.status.refused.label' },
        { value: 'confirmed', label: 'global.fields.status.confirmed.label' },
        { value: 'requested', label: 'global.fields.status.requested.label' },
        { value: 'draft', label: 'global.fields.status.draft.label' },
      ],
      valueToVariant: [
        { value: 'confirmed', variant: 'success' },
        { value: 'requested', variant: 'success' },
        { value: 'draft', variant: 'success' },
        { value: 'cancelled', variant: 'danger' },
        { value: 'refused', variant: 'danger' },
      ],
      toTranslate: true,
    };
  }

  get displayDayConfig(): object {
    return {
      displayType: 'days',
      sortable: true,
      order: 40,
      valueToLabel: {
        mon: 'bookings.schedule_slot_ranges.mon.header_label',
        tue: 'bookings.schedule_slot_ranges.tue.header_label',
        wed: 'bookings.schedule_slot_ranges.wed.header_label',
        thu: 'bookings.schedule_slot_ranges.thu.header_label',
        fri: 'bookings.schedule_slot_ranges.fri.header_label',
        sat: 'bookings.schedule_slot_ranges.sat.header_label',
        sun: 'bookings.schedule_slot_ranges.sun.header_label',
      },
    };
  }

  get changeDetectorStr(): string {
    return [
      this.filters.status,
      this.pagination.per_page,
      this.pagination.current_page,
      this.ordering.order_by,
      this.ordering.order_direction,
    ].join('--');
  }

  get hasCancelPermission(): boolean {
    const hasCancelPermission = this.$authorizationService.hasPermissionForAction(
      this.permissionEntityNameToUse ? this.permissionEntityNameToUse : this.pluralEntityName,
      'cancel_booking',
    );

    const hasCancelOwnPermission = this.$authorizationService.hasPermissionForAction(
      this.permissionEntityNameToUse ? this.permissionEntityNameToUse : this.pluralEntityName,
      'cancel',
      true,
    );
    const hasPublicCancelPermission = this.$authorizationService.hasPermissionForAction(
      this.permissionEntityNameToUse ? this.permissionEntityNameToUse : this.pluralEntityName,
      'manage_public_bookings',
      true,
    );

    const hasPermissionToCancel =
      hasCancelPermission || hasCancelOwnPermission || hasPublicCancelPermission;
    return hasPermissionToCancel;
  }

  // METHODS

  bookingCanBecancelled(booking: Booking): boolean {
    const cancellabelStatus: boolean =
      booking.status === 'requested' || booking.status === 'confirmed';
    return this.hasCancelPermission && cancellabelStatus;
  }

  clickOnView(item: Booking) {
    console.log('view', item);
    this.booking = item;
    this.showViewModal = true;
  }
  onCloseViewModal() {
    this.booking = null;
    this.showViewModal = false;
  }

  clickOnCancel(item: Booking) {
    console.log('cancel', item);
    this.booking = item;
    this.showCancelModal = true;
  }

  clickOnReload() {
    this.getBookingsIfStopChanging();
  }
  clickOnChangeOrderDirection(direction: string) {
    this.ordering.order_direction = direction;
  }

  getQueryParams() {
    return {
      order_by: this.ordering.order_by,
      order_direction: this.ordering.order_direction,
      per_page: this.pagination.per_page,
      page: this.pagination.current_page,
      status: this.filters.status,
    };
  }
  getUrlParams() {
    const urlQueryParams = JSON.parse(JSON.stringify(this.$route.query), (k, v) => {
      if (!isNaN(v) && !isNull(v)) {
        return parseInt(v);
      }
      return v;
    });
    return {
      ...urlQueryParams,
    };
  }
  setUrlParams(params) {
    if (this.withUrlParams) {
      this.$router.push({ query: params }).catch(e => {
        console.log(e);
        return null;
      });
    }
  }
  initializeFiltersFromProperties() {
    if (this.initialFilters) {
      this.filters = { ...this.initialFilters };
    }
  }
  initializeOrderingFromProperties() {
    if (this.orderBy) {
      this.ordering.order_by = this.orderBy;
    }

    if (this.orderDirection) {
      this.ordering.order_direction = this.orderDirection;
    }
  }
  initializeValuesFromUrlParams() {
    if (this.withUrlParams) {
      const urlParams = this.getUrlParams();

      if (!this.filters.status) {
        this.filters.status = urlParams?.status || null;
      }
      if (!this.orderBy) {
        this.ordering.order_by = urlParams?.order_by || 'code';
      }
      if (!this.orderDirection) {
        this.ordering.order_direction = urlParams?.order_direction || 'desc';
      }
    }
  }
  async getBookings() {
    this.loading = true;
    const params = this.getQueryParams();
    const url = this.$bpcApiRouteHelper.getEntityPath('bookings');
    const res = await this.$bpcApi.get(url + '/public-requests', { params: params }).toPromise();
    this.bookings = res.data;
    this.pagination = res.meta;
    this.setUrlParams(params);
    this.loading = false;
  }
  getBookingsIfStopChanging() {
    const changeStr = this.changeDetectorStr;
    setTimeout(() => {
      if (changeStr === this.changeDetectorStr) {
        this.getBookings();
      }
    }, 300);
  }

  onCloseCancelModal() {
    this.booking = null;
    this.showCancelModal = false;
  }

  onBookingCancelled() {
    this.getBookings();
    this.booking = null;
    this.showCancelModal = false;
  }

  // WATCHERS
  @Watch('changeDetectorStr')
  onChangeDetectorStrChange() {
    this.getBookingsIfStopChanging();
  }

  // LIFECYCLE
  mounted() {
    this.initializeFiltersFromProperties();
    this.initializeOrderingFromProperties();
    this.initializeValuesFromUrlParams();
    this.getBookingsIfStopChanging();
  }
}
